import React, { useEffect, useState } from 'react'
import "./product-question-answer.scss"
import { GetProductQuestionsAction } from "../../redux/actions/product-questions/getProductQuestions"
import StepButton from '../../common/StepButton';
import { SaveProductAnswersActions } from "../../redux/actions/product-questions/saveProductAnswers"
import TextInput from "../../common/TextInput"
import { toast } from "react-toastify"
import CustomRadioButton from "../../common/CustomRadioButton"
import { GetProductAnswerAction } from "../../redux/actions/product-questions/getProductAnswer"
import { useParams } from "react-router"
import ProductQuestionAnswerSkaleteon from "./ProductQuestionAnswerSkaleteon"
import Dropzone from 'react-dropzone';
import { MdOutlineFileUpload } from "react-icons/md";
import { webBaseUrl, frontendURL } from "../../../config"
import Cookies from 'js-cookie';
import { useSearchParams } from 'react-router-dom';
import ProductThankYouPage from "./ProductThankYouPage"
import ProductAnsClientId from './ProductAnsClientId';
import { FaRegFilePdf } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa";
import InfiniteScroll from 'react-infinite-scroll-component';

import { useSelector, useDispatch } from "react-redux"
import { CLEAR_PRODUCT_ANSWER_LIST } from "../../redux/constants/product-questions/getProductAnswerConst"
import { CLEAR_PRODUCT_QUESTION_LIST } from "../../redux/constants/product-questions/getProductQuestionConst"
import { SaveProductQuestionDocument } from "../../redux/actions/product-questions/saveProductQuestionDocument"
import { GetProductQuestionDocAction } from "../../redux/actions/product-questions/getProductQuestionDocument"
import quetionLogo from "../../../images/product-question/questionLogo.svg"
import SkeletonLoader from '../../common/Skeleton/SkeletonLoader';
import useWindowDimension from '../../../utils/useWindowDimensions';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CustomModal from '../../modal/CustomModal';


const PrductQuestionAnswer = () => {

  const dispatch = useDispatch()
  const [ansError, setAnsError] = useState("")
  const [step, setStep] = useState(1)

  const [clientIdFile, setClientIdFile] = useState(null)
  const [sendClientId, setSendClientId] = useState(null)
  const [productQue, setProductQue] = useState([])
  const [docError, setDocError] = useState(null)
  const slug = useParams();
  const [searchParams] = useSearchParams();
  const tokenParams = searchParams.get("token");
  const [manualStepChange, setManualStepChange] = useState(false);
  const [isExpanded,setIsExpanded]=useState(null)
  const [orderPlacedmodal, setorderPlacedmodal] = useState(false)

  const { getProductQuestionQueryData, initGetProductQuestionData } = GetProductQuestionsAction();
  const { initSaveProductAnswerData, saveProductAnswerQueryData } = SaveProductAnswersActions()
  const { getProductAnswerQueryData, initGetProductAnswerData } = GetProductAnswerAction()
  const { initSaveProductQuestionDocData, saveProductQuestionDocQueryData } = SaveProductQuestionDocument();
  const { initGetProductQuetionDocData, getProductQuestionDocQueryData } = GetProductQuestionDocAction()


  // ----------------------------product question reducer-----------------------------------------------

  const { productQuestionList } = useSelector((state) => state?.productQuestionListReducer)
  const { totalproductQuestionCount } = useSelector((state) => state?.productQuestionListReducer)
  const { loadedProductQuestionCount } = useSelector((state) => state?.productQuestionListReducer)
  const { productQuestionListPage } = useSelector((state) => state?.productQuestionListReducer)
  const { isIdentityRequired } = useSelector((state) => state?.productQuestionListReducer)


  // -------------------------------product answer reducer-----------------------------------------------------

  const { productAnswerList } = useSelector((state) => state?.productAnswerListReducer)
  const { totalProductAnswerCount } = useSelector((state) => state?.productAnswerListReducer)
  const { loadedProductAnswerCount } = useSelector((state) => state?.productAnswerListReducer)
  const { productAnswerListPage } = useSelector((state) => state?.productAnswerListReducer)
  const { isAllQuestionAnswered } = useSelector((state) => state?.productAnswerListReducer)
  const {success} = useSelector((state)=>state?.productAnswerListReducer)
const isClientIdUploaded = getProductAnswerQueryData?.data?.getProductAnswer?.data?.isClientIdUploaded;

  console.log("isAllQuestionAnswered", isAllQuestionAnswered)

  const initiateProductQuestionListCall = (refreshList = false) => {
    let newpage = productQuestionListPage + 1

    if (refreshList) {
      newpage = 1
    } else if (totalproductQuestionCount <= loadedProductQuestionCount) {
      return;
    }
    initGetProductQuestionData({
      page: newpage,
      limit: 10,
      orderId: parseInt(slug.orderId),
      token: tokenParams?.toString(),
      productId: null,
      slug: null,
      sessionId: null
    })
  }

  const initiateProductAnswerListCall = (refreshList = false) => {
    let newpage = productAnswerListPage + 1

    if (refreshList) {
      newpage = 1
    } else if (totalProductAnswerCount <= loadedProductAnswerCount) {
      return
    }


    initGetProductAnswerData({
      page: newpage,
      limit: 5,
      orderId: parseInt(slug.orderId),
      token: tokenParams?.toString()
    })
  }

  useEffect(() => {
    if (getProductQuestionQueryData?.data) {
      if (getProductQuestionQueryData?.data?.getProductQuestions?.success === false) {
        toast.error(getProductQuestionQueryData?.data?.getProductQuestions?.message);
      }
    }
  }, [getProductQuestionQueryData]);


  useEffect(() => {
    if (getProductQuestionQueryData?.data) {
      if (getProductQuestionQueryData?.data?.getProductQuestions?.success === false) {
        toast.error(getProductQuestionQueryData?.data?.getProductQuestions?.message);
      }
    }
  }, [getProductQuestionQueryData]);


  useEffect(() => {
    initGetProductQuestionData({
      page: 1,
      limit: 10,
      orderId: parseInt(slug.orderId),
      token: tokenParams?.toString(),
      productId: null,
      slug: null,
      sessionId: null
    })
  }, [])

  useEffect(() => {
    if(step === 1) {
      initGetProductAnswerData({
        page: 1,
        limit: 10,
        orderId: parseInt(slug.orderId),
        token: tokenParams?.toString()
      })
    }
  }, [step])


  useEffect(() => {
    dispatch({
      type: CLEAR_PRODUCT_QUESTION_LIST
    })
    initiateProductQuestionListCall(true)
  }, [])

  useEffect(() => {
    dispatch({
      type: CLEAR_PRODUCT_ANSWER_LIST
    })
    initiateProductAnswerListCall(true)
  }, [])

  console.log('productQuestionListPage', productQuestionListPage)


  useEffect(()=>{
    if(!manualStepChange){
      if(isAllQuestionAnswered && isClientIdUploaded){
       
        setStep(3)
      } else {
        if (isAllQuestionAnswered && isIdentityRequired) {
          setStep(2)
        }else{
          setStep(1)                    
        }
      }
    }

  }, [isAllQuestionAnswered, isClientIdUploaded, isIdentityRequired, getProductAnswerQueryData, manualStepChange])


  useEffect(() => {

    if (success) {
      // if (!(isAllQuestionAnswered && isClientIdUploaded) && !(isAllQuestionAnswered && isIdentityRequired)) {
         //   setorderPlacedmodal(true)
      // }
      if(!isAllQuestionAnswered){
        setorderPlacedmodal(true)
      }else{
        setorderPlacedmodal(false)
      }
    }
  }, [success])
  
  const onDrop = (acceptedFiles, i) => {
    if (acceptedFiles.length) {
      const uploadedFile = acceptedFiles[0];
      console.log('File uploaded:', uploadedFile);
      
      setProductQue(prev => 
        prev.map((doc, index) => 
          index === i ? { ...doc, doc_url: uploadedFile } : doc
        )
      );
    }
  }

  const handleFocus = (id) => {
    setIsExpanded(id)
  }

  const handleBlur = () => {
    setIsExpanded(null)
  }

  const openpdf=(fileUrl)=>{
    window.open(fileUrl)
  }

  const openVideoFile=(videoFile)=>{
      window.open(videoFile)
  }

  const openpdfLocal = () => {
    productQue?.forEach((file) => {
      if (file?.doc_url) {
        const blob = new Blob([file.doc_url], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
      }
    });
  }

  const handleText = (e, i) => {
    const updatedVal = e.target.value;
    setProductQue((prev) =>
      prev.map((item, index) =>
        index === i ? { ...item, answer: updatedVal } : item
      )
    );
  };


  const handleOption = (item, i) => {
    setProductQue(prev => prev.map((option, index) =>
      index === i ? { ...option, answer: item } : option
    ))
  }




  // useEffect(() => {
  //   if (productAnswerList && productQuestionList) {
  //     console.log("dgdgdfg", productQue)
  //     setProductQue((prevProductQue) => {
  //       const updatedProductQuestionList = productQuestionList.map((question) => {
  //         // Check if the question already exists in productQue and has an answer
  //         const existingQuestion = prevProductQue?.find((q) => q.id === question.id);

  //         if (existingQuestion && existingQuestion.answer) {
  //           // If the question exists and already has an answer, retain it
  //           return existingQuestion;
  //         }
  //         if (existingQuestion && existingQuestion.doc_url) {
  //           return existingQuestion;
  //         }

  //         // Find a matching answer for the question
  //         const matchedAnswer = productAnswerList.find(
  //           (answer) => answer.questionId === question.id
  //         );

  //         // Otherwise, update the question with the new answer or default values
  //         return {
  //           ...question,
  //           answer: matchedAnswer ? matchedAnswer.answer : null,
  //           doc_url: matchedAnswer ? matchedAnswer.doc_url : null,
  //         };
  //       });

  //       return updatedProductQuestionList;
  //     });
  //   }
  // }, [productAnswerList, productQuestionList]);


  useEffect(() => {
    if (productAnswerList && productQuestionList) {
      setProductQue((prevProductQue) => {
        const updatedProductQuestionList = productQuestionList.map((question) => {
          const existingQuestion = prevProductQue?.find((q) => q.id === question.id);
  
          // Retain existing answer or doc_url if already set
          if (existingQuestion && (existingQuestion.answer || existingQuestion.doc_url)) {
            return existingQuestion;
          }
  
          // Find all matched answers for this question
          const matchedAnswers = productAnswerList.filter(
            (answer) => answer.questionId === question.id
          );
  
          // Determine the correct values to store
          let selectedAnswer = null;
          let selectedDocUrl = null;
  
          matchedAnswers.forEach((ans) => {
            if (ans.answer) selectedAnswer = ans.answer;
            if (ans.doc_url) selectedDocUrl = ans.doc_url;
          });
  
          return {
            ...question,
            answer: selectedAnswer,
            doc_url: selectedDocUrl,
          };
        });
  
        return updatedProductQuestionList;
      });
    }
  }, [productAnswerList, productQuestionList]);
  

 
  




  const handleNextQuestionButton = () => {

    let hasError = false;
    const answersToSave = [];
    const errors = {};

    productQue?.forEach((que) => {
      let answer = null;
      let doc_url = null;

      if (que?.type === 1 && (!que?.answer || que?.answer.trim() === "")) {
        errors[que?.id] = errors[que?.id] || [];
        errors[que?.id].push("Please provide an answer.");
        hasError = true;
      }
      if (que?.type === 2 && !que?.answer) {
        errors[que?.id] = errors[que?.id] || [];
        errors[que?.id].push("Please select an option.");
        hasError = true;
      }
      if (que?.type === 3 && !que?.doc_url) {
        errors[que?.id] = errors[que?.id] || [];
        errors[que?.id].push("Please upload a PDF file.");
        hasError = true;
      }

      if (que?.type === 1) {
        answer = que?.answer;
      } else if (que?.type === 2) {
        answer = que?.answer?.toString();
      } else if (que?.type === 3) {
        if (que?.doc_url?.type?.includes("image") || que?.doc_url?.path?.includes('.pdf') || que?.doc_url.type?.includes("video")) {
          doc_url = que?.doc_url;
        } else {
          answer = que?.doc_url;
        }

      }

      answersToSave?.push({
        questionId: que?.id,
        answer:que?.type === 3 ?  null : answer,
        answerFile: doc_url,
      })
    })

    console.log("answersToSave", answersToSave)

    if (hasError) {
      setAnsError(errors);
      return;
    }


    setAnsError(null)
    initSaveProductAnswerData({

      token: tokenParams?.toString(),
      orderId: parseInt(slug.orderId),
      questions: answersToSave
    }, (data) => {

      toast.success("Answer saved!")
      if (isIdentityRequired) {
        setStep(2)
      } else {
        setStep(3)
      }

    }, (error) => {
      console.log(`error`, error);
    })
    // if(isIdentityRequired){
    //   setStep(2)
    // }else{
    //   setStep(3)
    // }

  }


  const handleBack = () => {
    setManualStepChange(true)
    if (step === 2 || isAllQuestionAnswered) {
      setStep(1)
    }
  }

  const submitClientDoc = () => {


    if (sendClientId === null && clientIdFile === null) {
      setDocError("please upload client ID");
      return;
    }

    setDocError(null)

    initSaveProductQuestionDocData({
      orderId: parseInt(slug.orderId),
      token: tokenParams?.toString(),
      answerFile: sendClientId
    }, (data) => {
      console.log(data)
      toast.success("ID uploaded successfully!")

      initGetProductQuetionDocData({
        orderId: parseInt(slug.orderId),
        token: tokenParams?.toString()
      })
      setStep(3)
    }, (error) => {
      console.log(error)

    })
  }

  useEffect(() => {
    initGetProductQuetionDocData({
      orderId: parseInt(slug.orderId),
      token: tokenParams?.toString()
    })
  }, [])

  useEffect(() => {

  }, [clientIdFile]);

  useEffect(() => {
    if (
      !sendClientId &&
      getProductQuestionDocQueryData?.data?.getProductQuestionDocument?.data
    ) {
      const docFile =
        getProductQuestionDocQueryData?.data?.getProductQuestionDocument?.data
          ?.doc_url;

      setClientIdFile(docFile);
    }
  }, [getProductQuestionDocQueryData?.data, sendClientId]);
  console.log("clientIdFile154", clientIdFile, sendClientId)


  const dimensions = useWindowDimension();
  const [paymentCardHeight, setPaymentCardHeight] = useState(0);
  const [submitBtnHeight, setSubmitBtnHeight] = useState(0);

  useEffect(() => {
    setPaymentCardHeight(
      document.getElementsByClassName('paymentCard')[0]?.offsetHeight
    );

    setSubmitBtnHeight(
      document.getElementsByClassName('submitBtnWrapper')[0]?.offsetHeight
    );

    window.addEventListener('resize', handleResize);
  }, [step, getProductQuestionQueryData, productQue]);

  const handleResize = () => {
    setPaymentCardHeight(
      document.getElementsByClassName('paymentCard')[0]?.offsetHeight
    );

    setSubmitBtnHeight(
      document.getElementsByClassName('submitBtnWrapper')[0]?.offsetHeight
    );

  };  
  
  return (
    <div className='MainProductQuestionQueryData'>
      {
        step === 1 && (
          <div className='container'>
            <div className='course-exam-main-div CustomeCourseExamSection maxWidth540'>
              <div className="course-work-cards-div">
                <div className='course-work-card questionaryWrap'>
                <div className='paymentCardWrapper'>
                  <div className='paymentCard'>
                    <div className='attentionLogo'>
                      <img src={quetionLogo} alt='quetionLogo' />
                    </div>
                    <div className='attentionText'>
                      <span>Attention</span>
                      <p>Before your order is sent, you need to complete the following medical health questions to check for eligibility</p>
                    </div>
                  </div>
                </div>

                  <div id="scrollableDiv">
                    <InfiniteScroll
                      dataLength={loadedProductQuestionCount}
                      next={
                        () => {
                          initiateProductQuestionListCall(false)
                          initiateProductAnswerListCall(false)
                        }}
                      hasMore={loadedProductQuestionCount < totalproductQuestionCount}
                      scrollableTarget="scrollableDiv"
                    >
                      {(
                        productQue?.map((que, i) => (
                          <div className='questionText'>
                            <p>{i + 1}{"."} {que?.question_text}</p>
                            <div className='answer-div'>
                              {
                                que?.type === 1 && (
                                  <>
                                    <div className='options'>
                                      <div className='text-area'>
                                        <TextInput
                                          id={que?.id}
                                          className={`answer-textbox-${que?.id}`}
                                          placeholder="Type your answer here"
                                          multiline={true}
                                          value={que?.answer}
                                          onFocus={() => handleFocus(`answer-textbox-${que?.id}`)}
                                          onBlur={handleBlur}
                                          rows="5"
                                          style={{
                                            minHeight: isExpanded === `answer-textbox-${que?.id}` ? "100px" : "20px",
                                            transition: "min-height 0.3s ease",
                                          }}
                                          onChange={(e) => { handleText(e, i) }}
                                        />
                                        {
                                          console.log("dvgdsfsdf", isExpanded)
                                        }
                                      </div>
                                    </div>
                                    <span className='answerError'>{ansError?.[que?.id]}</span>
                                  </>
                                )
                              }

                              {
                                que?.type === 2 && (
                                  <>
                                    <div className='optionsGrid'>
                                      {
                                        que?.options.map((op, index) => {

                                          return (
                                            <>
                                              <div
                                                className={`${que?.answer == op?.id ? "option-radiobutton-active option-radiobutton" : "option-radiobutton"}`}
                                                key={index}
                                                onClick={() =>
                                                  document.getElementById("question-answer-radio")
                                                    .addEventListener("change", handleOption(op?.id, i))
                                                }
                                              >
                                                <div className='optionsItem'>
                                                  <div className='optionsItemContent'>
                                                    <CustomRadioButton
                                                      id={"question-answer-radio"}
                                                      className="medium"
                                                      type="radio"
                                                      name={`option${op?.id}`}
                                                      checked={que?.answer == op?.id}
                                                      onChange={() => handleOption(op?.id, i)}
                                                      preselect={true}
                                                    />
                                                    {/* <span >
                                                          {String.fromCharCode(65 + index)} :
                                                        </span> */}
                                                  </div>
                                                  <div className='optionsItemContentLable'>
                                                    <label for={`option1`}>
                                                      <div className='label'>
                                                        <p className='p-0'>{op?.option_text}</p>
                                                      </div>
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )
                                        })
                                      }
                                    </div>
                                    <span className='answerError'>{ansError?.[que?.id]}</span>
                                  </>
                                )
                              }

                              {
                                que?.type === 3 && (
                                  <>
                                    <div className='choosefile-container'>
                                      <div className='input-file-div'>                                      
                                        <Dropzone
                                        accept={{
                                           'application/pdf': ['.pdf'],
                                           'image/png': ['.png'],
                                           'image/jpeg': ['.jpeg', '.jpg'],
                                           'video/mp4': ['.mp4'],
                                           'video/quicktime': ['.mov'],
                                           'video/webm': ['.webm']
                                         }}
                                  // accept={{'application/pdf': ['.pdf'],'image/png': ['.png'], 'image/jpeg': ['.jpeg'],'image/jpg': ['.jpg'] }}
                                  // onDrop={(acceptedFiles) => onDrop(acceptedFiles, i)}
                                  onDrop={(acceptedFiles) => {
                                    if (acceptedFiles[0].size >  10 * 1024 * 1024) {
                                      toast.error("Image  exceeds the 10 MB limit.")
                                    } else {
                                    onDrop(acceptedFiles, i)
                                    }
                                  }}
                                >
                                  {({ getRootProps, getInputProps,isDragActive}) => (
                                          
                                    <div {...getRootProps({className: "dropzone"})}>
                                      <label className='label' onClick={(e) => e.stopPropagation()}>
                                        <input {...getInputProps()} />
                                      
                                {/* {
                                  que?.doc_url ? 
                                  (
                                    que?.doc_url.type?.includes("image") ? (
                                    <div>
                                         <img src={URL.createObjectURL(que?.doc_url)} alt='Image' />
                                     </div>
                                      ): que?.doc_url?.path?.includes('.pdf') ? (
                                        <FaRegFilePdf  className='uploadedPdf' onClick={()=>openpdfLocal()}/>
                                      ) : que?.doc_url?.includes('.pdf') ? (
                                        <FaRegFilePdf  className='uploadedPdf' onClick={()=>openpdf(que?.doc_url)} />
                                      ):
                                      <div>
                                         <img src={que?.doc_url} alt='Image' />
                                     </div>
                                  ):
                                  (
                                    <span className={`label`} >
                                        <MdOutlineFileUpload  className='uploadImg' />
                                        <span className='imgText'>Upload file</span>
                                        <p className="doc-type-text">JPG, PNG, MP4, MOV, WEBM and PDF supported</p>
                                   </span>
                                  )
                                }  */}

                                {que?.doc_url ? (
                                     que?.doc_url.type?.includes("image") ? (
                                       <div>
                                         <img src={URL.createObjectURL(que?.doc_url)} alt="Image" />
                                       </div>
                                     ) : que?.doc_url.type?.includes("video") ? (
                                       <div>
                                         <FaVideo
                                           className="uploadedVideoIcon"
                                           onClick={() => window.open(URL.createObjectURL(que?.doc_url), "_blank")}
                                         />
                                         {/* <video controls width="300">
                                           <source src={URL.createObjectURL(que?.doc_url)} type={que?.doc_url.type} />
                                         </video> */}
                                       </div>
                                     ) : que?.doc_url?.path?.includes(".pdf") ? (
                                       <FaRegFilePdf className="uploadedPdf" onClick={() => openpdfLocal()} />
                                     ) : que?.doc_url?.includes(".pdf") ? (
                                       <FaRegFilePdf className="uploadedPdf" onClick={() => openpdf(que?.doc_url)} />
                                     ) : 
                                     que?.doc_url?.includes(".webm") || que?.doc_url?.includes(".mov") || que?.doc_url?.includes(".mp4") ? (
                                      <FaVideo
                                           className="uploadedVideoIcon"
                                           onClick={() => openVideoFile(que?.doc_url)}
                                         />
                                      ) : 
                                      (
                                       <div>
                                         <img src={que?.doc_url} alt="Image" />
                                       </div>
                                     )
                                   ) : (
                                     <span className="label">
                                       <MdOutlineFileUpload className="uploadImg" />
                                       <span className="imgText">Upload file</span>
                                       <p className="doc-type-text">
                                         JPG, PNG, MP4, MOV, WEBM, and PDF supported
                                       </p>
                                     </span>
                                   )}
                                
                                </label>
                                    </div>
                                  )}
                                </Dropzone>
                                   </div>
                                    </div>
                                    <span className='answerError'>{ansError?.[que?.id]}</span>
                                  </>
                                )
                              }
                            </div>
                          </div>
                        ))
                      )
                      }
                      {getProductQuestionQueryData?.loading && (productQuestionListPage > 0) &&
                        <Skeleton width={540} height={52} />
                      }
                      {getProductQuestionQueryData?.loading && (productQuestionListPage === 0) &&
                        <SkeletonLoader type={'questionSkeleton'} />}


                    </InfiniteScroll>
                  </div>

                  <div className='customSubmitBtnWrapper'>
                    <div className='submitBtnWrapper'>
                      <div className='submit-btn'>
                        <StepButton
                          label={isIdentityRequired && step === 1 ? "Save & next" : "submit"}
                          blue={true}
                          className={"prev-btn"}
                          onClick={() => {
                            handleNextQuestionButton();
                          }}
                          isLoading={saveProductAnswerQueryData?.loading}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        (step === 2 && getProductQuestionQueryData?.data?.getProductQuestions?.success !== false) && (
          <ProductAnsClientId
            handleBack={handleBack}
            setClientIdFile={setClientIdFile}
            clientIdFile={clientIdFile}
            setSendClientId={setSendClientId}
            sendClientId={sendClientId}
            submitClientDoc={submitClientDoc}
            docError={docError}
            setDocError={setDocError}
            loading={saveProductQuestionDocQueryData?.loading}
          />
        )
      }

      {
        step === 3 && (
          <ProductThankYouPage />
        )
      }
      <CustomModal
            modalOpen={orderPlacedmodal}
            setModalOpen={setorderPlacedmodal}
            modaltitle={"Order placed successfully!"}
          className={"customModalIntroTeammemberscreen maxWidth540"}
          shouldCloseOnOverlayClick={false}
          showCloseIcon={false}
          preventOverlayClose={true}
          modalBody={
              <>
                  <div className="first-time-intro-screen">
                      <div className="intro-screen-card-main">
                          <div className='intro-screen-card-content'>
                          <p>Before we can process your order, we need to confirm your eligibility. Please complete a quick questionnaire within 7 days. If there are any issues, we’ll reach out to you </p>
                          </div>
                      </div>
                        <StepButton label={"Ok"} blue={true} onClick={() => {setorderPlacedmodal(false)}}/>
                  </div>
              </>
          }
      />
      
      </div>
    )



}



export default PrductQuestionAnswer